import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocalizedDataSelector, useTranslate } from '@hooks';
import { fetchMediaCategories } from '@actions';
import { sortBy } from 'lodash';
import { Input } from '@dotone/react-ui-core';

const MediaCategorySelect = (props) => {
  const dispatch = useDispatch();
  const { locale } = useTranslate();
  const data = useLocalizedDataSelector(({ mediaCategoryList }) => mediaCategoryList);

  const options = [];

  sortBy(data, ['displayOrder']).forEach((mediaCategory) => {
    const childOptions = sortBy(mediaCategory.childCategories, ['displayOrder']).map(
      (category) => ({
        label: category.name,
        value: category.id,
      })
    );
    options.push({
      label: mediaCategory.name,
      options: sortBy(childOptions, ['displayOrder']),
    });
  });

  useEffect(() => {
    if (!data.length) {
      dispatch(fetchMediaCategories(locale));
    }
  }, [dispatch, data.length, locale]);

  return <Input type="select" grouped options={options} {...props} />;
};

export default MediaCategorySelect;
